import * as Actions from '../Actions/AtualizandoActions';

const initialState = {
    tentarNovamente: false,
    processando: false,
};

const AtualizandoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.ATUALIZANDO_TENTAR_NOVAMENTE:
            {
                return {
                    ...state,
                    tentarNovamente: action.payload,
                    processando: false,
                };
            }
        case Actions.ATUALIZANDO_PROCESSANDO:
            {
                return {
                    ...state,
                    processando: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

export default AtualizandoReducer;
